import React from "react";
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import AboutUsComponent from "./about.component";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";



const AboutComponent = () => {


    return (
        <>
             <Helmet>
              <title>ABOUT US SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
              <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
                <meta name="robots" content="index, follow" />
              </Helmet>
      <HeaderComponent/> 
      <NavbarComponent/>
      <section id="fixed-sub-nav" className="gradient-background" style={{paddingBottom: '30px', paddingTop: '30px'}}>
       <div className="container pt-4">
        
       <AboutUsComponent/>
 
      
       </div>
   
    </section>
    <FooterComponent/>
    </>
    );
};

export default AboutComponent;